export default __webpack_public_path__ + "fc94ba8b625f0b69c57cd9e2638bd5d5.png";